// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__14u8D","floatingWhatsapp":"styles_floatingWhatsapp__2n6Cz"};